import Vue from "vue";
import merge from "element-ui/src/utils/merge";
import { PopupManager } from "element-ui/src/utils/popup";
import Component from "./func-notification";

const NotificationConstructor = Vue.extend(Component);
const instances = []; // 储存通知组件实例列表
let instance;
let seed = 1; // 用来生成组件ID
const notifyCom = (options) => {
  if (Vue.prototype.$isServer) return;
  options = merge({}, options);
  const userOnClose = options.onClose;
  const id = "notificationCom_" + seed++;

  options.onClose = function() {
    notifyCom.close(id, userOnClose);
  };

  instance = new NotificationConstructor({
    data: options,
  });
  instance.id = id;
  instance.vm = instance.$mount();
  document.body.appendChild(instance.vm.$el);
  instance.visible = true;
  instance.dom = instance.$el;
  instance.dom.style.zIndex = PopupManager.nextZIndex();
  let verticalOffset = 0;
  instances.forEach((item) => {
    verticalOffset += item.$el.offsetHeight + 16;
  });
  verticalOffset += 16;
  instance.verticalOffset = verticalOffset;
  instances.push(instance);
  console.log(instances);
  return instance.vm;
};
notifyCom.close = function(id, userOnClose) {
  let index = -1;
  const len = instances.length;
  const instance = instances.filter((instance, i) => {
    if (instance.id === id) {
      index = i;
      return true;
    }
    return false;
  })[0];
  if (!instance) return;

  if (typeof userOnClose === "function") {
    userOnClose(instance);
  }
  instances.splice(index, 1);

  if (len <= 1) return;
  const removedHeight = instance.dom.offsetHeight;
  for (let i = index; i < len - 1; i++) {
    instances[i].dom.style[instance.verticalProperty] =
      parseInt(instances[i].dom.style[instance.verticalProperty], 10) -
      removedHeight -
      16 +
      "px";
  }
};
notifyCom.closeAll = function() {
  for (let i = instances.length - 1; i >= 0; i--) {
    instances[i].close();
  }
};

export default notifyCom;
